import { PairedCostVersion } from '@aloft/toolkit-shared';

import { FeaturesAndAdjustments } from '../types.js';

export const isValidForVersion = (
  version: PairedCostVersion,
  path: keyof FeaturesAndAdjustments,
): boolean => {
  switch (version) {
    case 'legacy':
      return !invalidRowsForV1.includes(path);
    case 'april_2024':
      return !invalidRowsForV2.includes(path);
    default:
      return true;
  }
};

const invalidRowsForV1: (keyof FeaturesAndAdjustments)[] = ['bathAboveGrade', 'bathBelowGrade'];
const invalidRowsForV2: (keyof FeaturesAndAdjustments)[] = [];
